import { useState } from "react";
import { timelineThreads } from "@/mocks/gossip";

const toneMap: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  primary: "bg-primary-100 text-primary-900 border-primary-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

export default function TimelineFeed() {
  const [sort, setSort] = useState<"new" | "hot">("new");
  const list = sort === "new" ? [...timelineThreads] : [...timelineThreads].reverse();

  return (
    <div>
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 px-1 py-1 rounded-full bg-background-100 border border-background-200">
          <button
            onClick={() => setSort("new")}
            className={
              "whitespace-nowrap rounded-full px-3.5 py-1 text-sm transition " +
              (sort === "new" ? "bg-primary-500 font-medium text-background-50" : "text-foreground-600")
            }
          >
            最新动态
          </button>
          <button
            onClick={() => setSort("hot")}
            className={
              "whitespace-nowrap rounded-full px-3.5 py-1 text-sm transition " +
              (sort === "hot" ? "bg-primary-500 font-medium text-background-50" : "text-foreground-600")
            }
          >
            热度优先
          </button>
        </div>
        <span className="hidden items-center gap-1.5 whitespace-nowrap text-xs text-secondary-700 sm:flex">
          <span className="h-1.5 w-1.5 animate-soft-pulse rounded-full bg-secondary-500"></span>
          持续吃瓜中 · 新进展随时顶上来
        </span>
      </div>

      <ol className="relative space-y-5 before:absolute before:left-[19px] before:top-2 before:bottom-2 before:w-px before:bg-background-200">
        {list.map((t) => (
          <li key={t.id} className="relative pl-14">
            <span className="absolute left-0 top-0 z-10 flex h-10 w-10 items-center justify-center rounded-full border-2 border-background-50 bg-background-100 text-sm font-bold text-primary-700">
              <i className="ri-stack-line"></i>
            </span>
            <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-2">
                <span className={"whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium border " + toneMap[t.categoryTone]}>
                  {t.category}
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] text-accent-700">
                  <i className="ri-arrow-up-line"></i>有新进展顶上来
                </span>
              </div>
              <a href="#floor" className="mt-2 block font-heading text-base font-bold leading-snug text-foreground-950 hover:text-primary-700 md:text-lg">
                {t.title}
              </a>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{t.excerpt}</p>

              <div className="mt-3 rounded-md bg-background-50 border-l-2 border-primary-500 px-3 py-2.5">
                <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded bg-primary-100 px-1.5 py-0.5 font-medium text-primary-800">
                    <i className="ri-stack-line"></i>第 {t.latest.floor} 楼
                  </span>
                  <span>{t.latest.by}</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-time-line"></i>{t.latest.time}</span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-800">{t.latest.text}</p>
              </div>

              <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-foreground-500">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="inline-flex items-center gap-1"><i className="ri-stack-fill text-primary-600"></i>{t.floor} 楼</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>蹲帖中</span>
                </div>
                <a href="#floor" className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-primary-700 hover:text-primary-800">
                  进楼看进展<i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}